import HelpAction from "./HelpAction";
import Legenda from "./Legenda";
import { useState } from "react";
import PainelVal from "./PainelVal";
import { limpa, limpaLegenda, valid, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2 } from "./Aux.js";


const Val = (props) => {

    props.setComp('val');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar validações em estações. Query validations at stations.');
    
    const [csv, setCsv] = useState('');
    var specs = {...props.specs};
    
    function valQuery(e) {
        e.preventDefault();
        limpaLegenda();
        let s = {...props.specs};
        let tipo = props.specs.tipo;
        if (tipo !== '') {
            tipo = tipo.split(" ");
            tipo = limpa(tipo, 1, 7, props.ling, '1');
        }
        s.tipo = tipo.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let ltipo = [];
        for (let i = 0; i < tipo.length; i++) {
            ltipo.push(props.varGlob.dsem[parseInt(tipo[i])-1]);
        }
        let dmes = props.specs.dmes;
        if (dmes !== '') {
            dmes = dmes.split(" ");
            dmes = limpa(dmes, 1, 31, props.ling, '1');
        }
        s.dmes = dmes.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2019 2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2019, 2021, props.ling, 2021);
        if( anos.length < 1) {
            anos = ['2019', '2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')
        };
        s.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if( meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i])-1]);
        }
        s.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let horas = props.specs.horas;
        if (horas === '') {
            horas = '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24';
        }
        horas = horas.split(" ");
        horas = limpa(horas, 1, 24, props.ling, 8);
        if( horas.length < 1) {
            horas = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            alert('Input errado para horas foi substituído. / Wrong input for hours was replaced.')
        };
        s.horas = horas.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        specs = s;
        let mensagem = "Coloridas estações em função do número de validações<br>";
        mensagem += "<br>Do(s) ano(s):      " + anos; 
        mensagem += "<br>No(s) mes(es):      " + lmeses; 
        mensagem += "<br>Na(s) hora(s):      " + horas; 
        let filtro = anos + ";" + lmeses + ";" + horas + ";" ;   
        if (ltipo.length > 0){
            filtro += ltipo + ";";
            mensagem += "<br>Nos dias tipo:     "  + ltipo; 
        }
        if (props.specs.fer !== props.specs.nfer){
            if (props.specs.fer === 0){
                filtro += " Não feriado ;";
                mensagem += " Não feriado " ;
            } else {
                filtro += " Feriado ;";
                mensagem += " Feriado " ;
            }
        }
        if (dmes.length>0){
            filtro += dmes + ";";
            mensagem += "<br>Nos dias do mês:    "  + dmes;
        }
        let fer = 0;
        let nfer = 0;
        if (props.specs.fer) fer = 1;
        if (props.specs.nfer) nfer = 1;
        const params = {
            "serv": "val",
            "anosl": anos,
            "mesesl": meses,
            "horasl": horas,
            "tipo": tipo,
            "dmes": dmes,
            "fer": fer,
            "nfer": nfer
        };
        valFetchAsync (
            "/bqmapsnode/?params="  + JSON.stringify(params), filtro
        );
    };

    async function valFetchAsync (url, filtro) {
        let response = await fetch (url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados.length < 1) {
                valAlertaDados();
                return resultados;
            } else { 
                console.log(resultados);
                let s = {...specs};
                s.res = resultados;
                props.setSpecs(s);
                valSavecsv(resultados, filtro);
                return resultados;
            }
        } else {
            console.log(url, response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    }

    function valAlertaDados() {
        if (props.ling === 'pt') {
            alert ('Não há dados para o período especificado! Só de Jan 2019 a Fev 2021, inc. (excepto Abr 2020)');
        } else {
            alert ('No data for the specified period! Only for Jan 2019 to Feb 2021, inc. (Apr 2020 excluded)')
        }
    }

    async function valSavecsv(resultados, filtro){
        setCsv('');
        let ponto = resultados[0];
        let campo = Object.keys(ponto);
        let nloc = resultados.length;
        let csvCont = "Anos;Meses;Horas;Dias; \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "N.º;Código;Validações \n";
        for (let i=0; i<nloc; i++){
            let j = resultados[i][campo[0]];
            csvCont = csvCont + j + ";";
            if (j < 84) {
                csvCont = csvCont + props.varGlob.e[j] + ";";
            }
            csvCont = csvCont + parseInt(resultados[i][campo[3]]) + "\n";
        }
        let response = await fetch ("/bqmapsnode/?fileToWrite=" + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        console.log (fileName);
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
        setCsv(fileName);
    }

    /* useEffect(() => {
        document.getElementById("menu").style.marginLeft = '160px';
    }, [] ); */
    
    
    return ( 
        <div className="val">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpAction 
                        ling={props.ling} 
                        titPt={"Colorir estações em função do número de validações"}
                        titUk={"To color stations according to the number of validations"}
                        helpPt={"https://docs.google.com/presentation/d/1S9WYZQSRvRfeAPZPR15lDSAqD1evmBwflV1GiqFuAbo/edit?usp=sharing"}
                        helpUk={"https://docs.google.com/presentation/d/1NzErzG9iB6AxQrt8rUbgIm_I0Lqmrk3B9H7DExn8ie4/edit?usp=sharing"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={valQuery}
                        csv={csv}
                        download={download} />
                    <PainelVal
                        ling={props.ling}
                        specs={props.specs}
                        setSpecs={props.setSpecs}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob}
                        BotA1={'OD Et'}
                        TitA1={"Colorir estações em função do número de etapas"}
                        RefA1={"ode"}  />
                    <Legenda />
                </div>   
            </div>
        </div>
    );
    }


export default Val;